<template>
    <div class="container-fluid w-100 pb-3" style="overflow: hidden">
          <navbar :title="$t('users.users_title')"/>
          <div class="col-sm-12 nopads my-2">
              <user-search v-if="isAdmin" @search="fetchUsers"/>
          <Transition name="fade">
            <user-list
              :can-add="true"
              :results="results"
              @add="addUser"
              @edit="editUser"
            />
          </Transition>
          <base-modal size="lg" v-if="editMode" hide-header hide-footer>
              <user-editor
                  :is-admin="isAdmin"
                  :user-to-edit="user"
                  :user="userAccount"
                  @close="showList"
                  @close-and-update="closeAndUpdate"
              />
          </base-modal>
          <div
            v-if="loading"
            id="loader"
            class="spinner"
          />
        </div>
  </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {userHelper} from '../mixins/UserMixin'
import UserList from './UserList'
import UserEditor from './UserEditor'
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";
import UserSearch from "./UserSearch.vue";

export default {
    name: 'Users',
    components: {UserSearch, BaseModal, Navbar, UserList, UserEditor},
    mixins: [restApi, userHelper],
    props: {
        userAccount: {
            type: Object,
            default: null
        },
        isAdmin: Boolean,
        isSuperUser: Boolean
    },
    data: function () {
        return {
            results: [],
            user: null,
            editMode: false,
            loading: false,
            lastSearchParams: null
        }
    },
    mounted() {
        if (!this.isAdmin) {
            this.fetchUsers({})
        }
    },
    methods: {
        fetchUsers: function (params) {
            this.loading = true
            this.results = []
            this.lastSearchParams = params
            this.restFetchParams(this.userUrl, params, this.handleResponse)
        },

        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
        },

        editUser: function (user) {
            this.user = user
            this.editMode = true
        },

        addUser: function () {
            this.user = this.newUser()
            this.editMode = true
        },

        closeAndUpdate: function () {
            this.fetchUsers(this.lastSearchParams)
            this.editMode = false
        },

        showList: function () {
            this.editMode = false
        },

    }
}
</script>
